export default {
  SET_SUCCESSFUL_BIDDERS(state, payload) {
    state.list = (payload || [])
      .reduce((index, option) => ({
        ...index,
        [option.adjudicatarioId]: option
      }), {});
  },
  SET_SELECTED_SUCCESSFUL_BIDDER(state, payload) {
    state.selectedBidder = payload;
  },
  SET_PAGINATION(state, { items, pages }) {
    state.pagination = {
      items,
      pages
    };
  },
  UPDATE_STATUS_BIDDER(state, { adjudicatario }) {
    state.list[adjudicatario.adjudicatarioId].estadoActivo = adjudicatario.estadoActivo;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  }
};
